module.exports = __webpack_public_path__ + "static/media/tcb-logo.03b80927.png";